import { memo } from 'react';
import { Input, Stack } from '@chakra-ui/react';

import { RequiredFieldLabel } from '@/components/forms/RequiredFieldLabel';
import { Field } from '@/components/ui/field';
import { ScreeningType } from '@/types/enums';
import { Client } from '@/types/Client';
import { Job } from '@/types/Job';
import {
  Candidate,
  CandidateWithJobContext,
  CandidateWithJobContextBasicInfo
} from '@/types/Candidate';

const ErrorMessage = ({ message }: { message?: string }) =>
  message ? (
    <div style={{ fontSize: '14px', color: 'var(--chakra-colors-error-700)' }} role="alert">
      {message}
    </div>
  ) : null;

interface UpdateModeFieldsProps {
  screeningType: ScreeningType;
  client: Client | null;
  job: Job | null;
  candidate: Candidate | CandidateWithJobContext | CandidateWithJobContextBasicInfo | null;
  errors: Record<string, { message?: string }>;
}

export const UpdateModeFields: React.FC<UpdateModeFieldsProps> = memo(
  ({ screeningType, client, job, candidate, errors }) => (
    <Stack gap="24px">
      {screeningType === ScreeningType.JobInterview && (
        <>
          <Field
            label={<RequiredFieldLabel fontWeight="semibold">Client</RequiredFieldLabel>}
            invalid={!!errors.client}
            errorText={<ErrorMessage message={errors.client?.message} />}
          >
            <Input
              value={client?.name || 'N/A'}
              disabled
              size="lg"
              borderRadius="8px"
              bg="neutrals.100"
            />
          </Field>

          <Field
            label={<RequiredFieldLabel fontWeight="semibold">Job</RequiredFieldLabel>}
            invalid={!!errors.job}
            errorText={<ErrorMessage message={errors.job?.message} />}
          >
            <Input
              value={(job as Job)?.job_title || 'N/A'}
              disabled
              size="lg"
              borderRadius="8px"
              bg="neutrals.100"
            />
          </Field>
        </>
      )}

      <Field
        label={<RequiredFieldLabel fontWeight="semibold">Candidate</RequiredFieldLabel>}
        invalid={!!errors.candidate}
        errorText={<ErrorMessage message={errors.candidate?.message} />}
      >
        <Input
          value={candidate?.first_name || 'N/A'}
          disabled
          size="lg"
          borderRadius="8px"
          bg="neutrals.100"
        />
      </Field>
    </Stack>
  )
);

UpdateModeFields.displayName = 'UpdateModeFields';
